(function () {
  'use strict';

  function initAncDemo(root, opts) {
    if (!root || root.__ancInitialized) return;
    root.__ancInitialized = true;

    opts = opts || {};
    var settings = {
      offMusicVolume: (typeof opts.offMusicVolume === 'number' ? opts.offMusicVolume : 55) / 100,
      offNoiseVolume: (typeof opts.offNoiseVolume === 'number' ? opts.offNoiseVolume : 90) / 100,
      onMusicVolume: (typeof opts.onMusicVolume === 'number' ? opts.onMusicVolume : 100) / 100,
      onNoiseVolume: (typeof opts.onNoiseVolume === 'number' ? opts.onNoiseVolume : 15) / 100,
      fadeMs: opts.fadeMs || 450,
      onLabel: opts.onLabel || 'ON',
      offLabel: opts.offLabel || 'OFF'
    };

    var video = root.querySelector('[data-anc-video]');
    var switchBtn = root.querySelector('[data-anc-switch]');
    var thumbText = root.querySelector('[data-anc-thumb-text]');
    var playBtn = root.querySelector('[data-anc-play]');
    var iconPlay = playBtn ? playBtn.querySelector('.anc-demo__icon-play') : null;
    var iconPause = playBtn ? playBtn.querySelector('.anc-demo__icon-pause') : null;

    var music = root.querySelector('[data-anc-music]') || document.querySelector('[data-anc-music]');
    var noise = root.querySelector('[data-anc-noise]') || document.querySelector('[data-anc-noise]');

    var hasMusic = !!(music && music.querySelector('source') && music.querySelector('source').getAttribute('src'));
    var hasNoise = !!(noise && noise.querySelector('source') && noise.querySelector('source').getAttribute('src'));

    var ancOn = true;
    var isVisible = false;
    var userPaused = false; // true once the visitor presses pause
    var fadeRaf = null;

    /* ---------- UI helpers ---------- */

    function setToggleUI() {
      if (!switchBtn) return;
      switchBtn.setAttribute('aria-checked', ancOn ? 'true' : 'false');
      if (thumbText) {
        thumbText.textContent = ancOn ? settings.onLabel : settings.offLabel;
      }
    }

    function isAudioPlaying() {
      return (hasMusic && !music.paused) || (hasNoise && !noise.paused);
    }

    function setPlayUI() {
      if (!playBtn) return;
      var playing = isAudioPlaying();
      playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      playBtn.setAttribute('aria-label', playing ? 'Pause audio' : 'Play audio');
      if (iconPlay) iconPlay.style.display = playing ? 'none' : '';
      if (iconPause) iconPause.style.display = playing ? '' : 'none';
    }

    /* ---------- Volume ---------- */

    function targetVolumes() {
      return {
        music: ancOn ? settings.onMusicVolume : settings.offMusicVolume,
        noise: ancOn ? settings.onNoiseVolume : settings.offNoiseVolume
      };
    }

    // Force volume levels synchronously onto audio elements
    function applyCurrentState() {
      var target = targetVolumes();
      if (hasMusic) music.volume = target.music;
      if (hasNoise) noise.volume = target.noise;
    }

    function crossfadeTo(target, duration) {
      if (fadeRaf) cancelAnimationFrame(fadeRaf);

      var startMusic = hasMusic ? music.volume : 0;
      var startNoise = hasNoise ? noise.volume : 0;
      var startTime = performance.now();

      function step(now) {
        var t = Math.min(1, (now - startTime) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        if (hasMusic) music.volume = startMusic + (target.music - startMusic) * eased;
        if (hasNoise) noise.volume = startNoise + (target.noise - startNoise) * eased;
        if (t < 1) {
          fadeRaf = requestAnimationFrame(step);
        } else {
          applyCurrentState();
        }
      }
      fadeRaf = requestAnimationFrame(step);
    }

    function syncPlayheads() {
      if (!hasMusic || !hasNoise) return;
      if (music.paused || noise.paused) return;
      if (music.readyState < 3 || noise.readyState < 3) return;

      try {
        if (Math.abs(music.currentTime - noise.currentTime) > 0.15) {
          noise.currentTime = music.currentTime;
        }
      } catch (e) {}
    }

    /* ---------- Playback ---------- */

    function playVideo() {
      if (video && video.paused && typeof video.play === 'function') {
        video.muted = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    function startAudio() {
      // Set target volumes BEFORE play() (mobile fix)
      applyCurrentState();

      if (hasMusic && music.paused) {
        var p1 = music.play();
        if (p1 && p1.catch) p1.catch(function () {});
      }
      if (hasNoise && noise.paused) {
        var p2 = noise.play();
        if (p2 && p2.catch) p2.catch(function () {});
      }

      // Re-apply volumes right after playback starts to override mobile defaults
      applyCurrentState();
      setPlayUI();
    }

    function stopAudio() {
      if (hasMusic) music.pause();
      if (hasNoise) noise.pause();
      setPlayUI();
    }

    function pauseAll() {
      if (video) video.pause();
      stopAudio();
    }

    // Audio may be auto-started only when the section is on screen
    // and the visitor has not pressed pause.
    function canAutoPlay() {
      return isVisible && !userPaused;
    }

    /* ---------- Play / pause button ---------- */

    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (isAudioPlaying()) {
          userPaused = true;
          stopAudio();
        } else {
          userPaused = false;
          startAudio();
        }
      });
    }

    if (hasMusic) {
      music.addEventListener('play', setPlayUI);
      music.addEventListener('pause', setPlayUI);
    }
    if (hasNoise) {
      noise.addEventListener('play', setPlayUI);
      noise.addEventListener('pause', setPlayUI);
    }

    /* ---------- First-gesture unlock ----------
       Browsers block sound until the visitor taps/clicks (scrolling does not count).
       On the first real gesture, start audio only if the section is visible
       and the visitor has not paused. */

    function handleGlobalUnlock(e) {
      // Ignore taps on the play button: it handles itself
      if (playBtn && e && e.target && playBtn.contains(e.target)) return;

      if (canAutoPlay()) startAudio();

      window.removeEventListener('pointerdown', handleGlobalUnlock);
      window.removeEventListener('touchstart', handleGlobalUnlock);
      window.removeEventListener('click', handleGlobalUnlock);
    }

    window.addEventListener('pointerdown', handleGlobalUnlock, { passive: true });
    window.addEventListener('touchstart', handleGlobalUnlock, { passive: true });
    window.addEventListener('click', handleGlobalUnlock, { passive: true });

    /* ---------- ANC switch ---------- */

    if (switchBtn) {
      switchBtn.addEventListener('click', function (e) {
        e.stopPropagation();

        ancOn = !ancOn;
        setToggleUI();

        // Respect a manual pause; otherwise make sure sound is playing
        if (!userPaused) startAudio();

        if (isVisible) {
          crossfadeTo(targetVolumes(), settings.fadeMs);
        } else {
          applyCurrentState();
        }
      });
    }

    /* ---------- Scroll observer ---------- */

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              isVisible = true;
              playVideo();
              // Tries to play; silently stays paused if the browser blocks it
              if (!userPaused) startAudio();
            } else {
              isVisible = false;
              pauseAll();
            }
          });
        },
        { threshold: 0.3 }
      );
      io.observe(root);
    } else {
      isVisible = true;
      playVideo();
    }

    setToggleUI();
    applyCurrentState();
    setPlayUI();

    if (hasMusic) {
      music.addEventListener('timeupdate', syncPlayheads);
    }
  }

  window.initAncDemo = initAncDemo;
})();